const getters = {
  initialStation: state => state.book.initialStation,
  terminalStation: state => state.book.terminalStation,
  currentUser: state => state.user.currentUser,
  isCollapse: state => state.app.isCollapse,
  contractCodeList: state => state.book.contractCodeList,
  findPoints: state => state.book.findPoints,
  searchOn: state => state.book.searchOn,
  searchDate: state => state.book.searchDate,
  contractNumber: state => state.book.contractNumber,
  routeList: state => state.book.routeList,
  selectedPath: state => state.book.selectedPath,
  referenceNo: state => state.book.referenceNo,
  roleList: state => state.book.roleList,
  companyName: state => state.book.companyName,
  companyAddress: state => state.book.companyAddress,
  goodsDetail: state => state.book.goodsDetail,
  officeInfo: state => state.book.officeInfo,
  payInfo: state => state.book.payInfo,
  goodsList: state => state.book.goodsList,
  airLineList: state => state.book.airLineList,
  historyList: state => state.book.historyList,
  goodsHistory: state => state.book.goodsHistory,
  activeIndex: state => state.book.activeIndex,
  bookingList: state => state.order.bookingList,
  totalCount: state => state.order.totalCount,
  current: state => state.order.current,
  size: state => state.order.size

}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js